const EXPERIMENTS = {
    buttonCTA: 'buttonCTA'
};

export { EXPERIMENTS };
